:host {
  width: 100%;
}

.mic-icon {
  fill: var(--ai12z-mic-color);
}

.mic-botIcon {
  fill: var(--ai12zBot-v2-searchbar-mic-color);
}
